export default (errorResponse, handlers) => dispatch =>
  handlers.some(handler => dispatch(handler(errorResponse)));
